export interface investItem{
    //id
    id:string,
    //名字
    name:string,
    //描述
    explain:string,
    //小icon
    icon:string,
    //价格
    price:number[],
    //首次购买的最多份数
    oneCount:number,
    //后续每次补仓可以购买的份数
    followCount:number
}

//城市
export interface cityItemI{
    //id
    id:string,
    //名字
    name:string,
    //出现的权重
    weight:number,
    //描述
    explain:string,
    //背景板图片
    bgSpPath:string,
    //开始的音效
    startSound:string,
    //可能出现的物品
    items:string[][]
}

export interface investMap{
    [id:string]:investItem;
}

export interface cityMap{
    [id:string]:cityItemI;
}

let itemAry:investItem[] = null;

export function getInvestItemAry(){
    if(!itemAry){
        itemAry = [
            {id:"0",name:"煤炭",explain:"可持久燃烧取暖的生活物品",icon:"0",price:[20,40],oneCount:800,followCount:400},
            {id:"1",name:"木材",explain:"可短暂燃烧取暖的生活物品",icon:"1",price:[10,20],oneCount:1000,followCount:500},
            {id:"2",name:"棉衣",explain:"为了御寒在中间加了保温材料的衣服",icon:"2",price:[50,100],oneCount:300,followCount:100},
            {id:"3",name:"短袖",explain:"炎热天气为了遮体设计出所穿的衣服",icon:"3",price:[30,50],oneCount:800,followCount:300},
            {id:"4",name:"养猪场",explain:"能大量提供肉食所办的场所",icon:"4",price:[1000,2000],oneCount:10,followCount:10},
            {id:"5",name:"农场",explain:"能大量提供素食所办的场所",icon:"5",price:[100,200],oneCount:20,followCount:10},
            {id:"6",name:"切尔西",explain:"穿上以后能提高移动速度",icon:"6",price:[1000,2000],oneCount:100,followCount:50},
            {id:"7",name:"反甲",explain:"一种伤敌一千自损八百的战甲，",icon:"7",price:[2000,3000],oneCount:50,followCount:20},                
            {id:"8",name:"老子兵法",explain:"老子兵法比孙子兵法还要厉害",icon:"8",price:[10,20],oneCount:1000,followCount:200},
            {id:"9",name:"烟雾蛋",explain:"一种烟熏出的鸭蛋，开吃的时候建议在宽敞的地方",icon:"9",price:[50,100],oneCount:300,followCount:100},
            {id:"10",name:"泰裤辣",explain:"一种进口的食物，泰裤辣",icon:"10",price:[20,50],oneCount:2000,followCount:500},
            {id:"11",name:"老谭酸菜",explain:"发酵10天以上而成的腌渍蔬菜",icon:"11",price:[10,20],oneCount:1200,followCount:200},
            {id:"12",name:"罗非鱼",explain:"今天晚上吃啥子，罗非罗非罗非鱼",icon:"12",price:[20,50],oneCount:2000,followCount:500}, 
            {id:"13",name:"九转大肠",explain:"保留一点，不然你怎么知道吃的是大肠",icon:"13",price:[20,40],oneCount:800,followCount:400},
            {id:"14",name:"女儿红",explain:"冬天空气潮湿寒冷人们常饮用此酒来御寒",icon:"14",price:[50,100],oneCount:500,followCount:200}, 
            {id:"15",name:"咸鸭蛋",explain:"一种用盐腌制的蛋，最好别一口吃一个哟",icon:"15",price:[5,10],oneCount:2000,followCount:500},
            {id:"16",name:"冰块",explain:"通常用来降温或制作冰饮",icon:"16",price:[20,50],oneCount:1000,followCount:300},
            {id:"17",name:"火锅",explain:"一种老少皆宜的食物",icon:"17",price:[30,50],oneCount:800,followCount:200},
            {id:"18",name:"盐巴",explain:"老一辈人习惯把盐称作盐巴",icon:"18",price:[10,20],oneCount:2000,followCount:500},
            {id:"19",name:"土豆",explain:"世界上许多国家重要的食品",icon:"19",price:[5,10],oneCount:5000,followCount:1000},
            {id:"20",name:"铁矿",explain:"利用最广，用量也是最多的一种金属",icon:"20",price:[10000,50000],oneCount:20,followCount:2},
            {id:"21",name:"铜矿",explain:"铜最耐用的金属，平常百姓使用较多",icon:"21",price:[20000,80000],oneCount:10,followCount:1},                
            {id:"22",name:"馒头",explain:"是一种用发酵的面蒸成的食品",icon:"22",price:[1,5],oneCount:5000,followCount:1000},
            {id:"23",name:"腊肉",explain:"是指肉经腌制后所制成的加工食品",icon:"23",price:[20,50],oneCount:1200,followCount:400},
            {id:"24",name:"大米",explain:"一种广为人知的食物",icon:"24",price:[20,50],oneCount:1200,followCount:300},
            {id:"25",name:"小麦",explain:"可以制作成很多种食物",icon:"25",price:[10,20],oneCount:2000,followCount:400},
            {id:"26",name:"蜡烛",explain:"可燃烧发出光亮，是一种日常照明工具",icon:"26",price:[5,10],oneCount:4000,followCount:1000}, 
            {id:"27",name:"瓷器",explain:"是古代劳动人民的一个重要的创造",icon:"27",price:[10,20],oneCount:2000,followCount:400},  
            {id:"28",name:"方便面",explain:"一种可在短时间之内用热水泡熟食用的面制食品",icon:"28",price:[10,20],oneCount:2000,followCount:400}, 
            {id:"29",name:"羊毛",explain:"柔软而富有弹性，一般用来制成御寒之物",icon:"29",price:[10,20],oneCount:2000,followCount:400},
        ]
    }
    return itemAry;
}

let investItemMap : investMap = null;

export function getInvestItemMap(){
    let ary = getInvestItemAry();
    if(!investItemMap){
        investItemMap = <investMap>{};
        for(let a of ary){
            investItemMap[a.id] = a;
        }
    }
    return investItemMap;
}

let cityAry:cityItemI[] = null;

export function getCityItemAry(){
    if(!cityAry){
        cityAry = [
            {id:"1000",weight:7,name:"NP港",explain:"台风天气席卷NP港，你选择收购",bgSpPath:"0",startSound:"",items:[["0","1"],["2","3"],["10","11"],["12","13"],["18","19"],["24","25"],["28","29"]]},
            {id:"1001",weight:7,name:"逐鹿",explain:"逐鹿频频战乱，百姓民不聊生，你选择投资",bgSpPath:"1",startSound:"",items:[["2","3"],["4","5"],["6","7"],["8","9"],["14","15"],["28","29"]]},
            {id:"1002",weight:7,name:"江南",explain:"江南雨水泛滥，庄家尽毁，你选择投资",bgSpPath:"2",startSound:"",items:[["2","3"],["4","5"],["22","23"],["24","25"],["28","29"]]},
            {id:"1003",weight:7,name:"幽州城",explain:"幽州城，官家欺压百姓，大量百姓背景离乡，你选择投资",bgSpPath:"3",startSound:"",items:[["0","1"],["2","3"],["4","5"],["14","15"],["24","25"]]},
            {id:"1004",weight:7,name:"常山",explain:"常山黄沙漫天，百姓颗粒无收，你选择投资",bgSpPath:"4",startSound:"",items:[["0","1"],["2","3"],["4","5"],["22","23"],["24","25"]]},
            {id:"1005",weight:7,name:"琼州岛",explain:"琼州夏日炎炎，常年高温，你选择投资",bgSpPath:"5",startSound:"",items:[["0","1"],["2","3"],["4","5"],["12","13"],["14","15"],["16","17"],["18","19"]]},
            {id:"1006",weight:7,name:"蓬莱岛",explain:"蓬莱四季如春，少于内陆往来，你选择投资",bgSpPath:"6",startSound:"",items:[["2","3"],["10","11"],["12","13"],["14","15"],["26","27"]]},        
            {id:"1007",weight:7,name:"玄冬城",explain:"玄冬城即将引来暴风雪，你选择投资",bgSpPath:"7",startSound:"",items:[["0","1"],["2","3"],["14","15"],["16","17"]]},
            {id:"1008",weight:7,name:"契丹城",explain:"契丹城入住大批外国富商，你选择投资",bgSpPath:"8",startSound:"",items:[["0","1"],["2","3"],["10","11"],["12","13"],["26","27"]]},
            {id:"1009",weight:7,name:"苍南岭",explain:"苍南岭犹如仙境，常年大雾，你选择投资",bgSpPath:"9",startSound:"",items:[["0","1"],["2","3"],["18","19"],["22","23"]]},
            {id:"1010",weight:2,name:"勃矿山",explain:"勃矿山地广人稀，矿场丰富，你选择投资",bgSpPath:"10",startSound:"",items:[["0","1"],["2","3"],["20","21"]]},
            {id:"1011",weight:7,name:"官渡城",explain:"官渡城富商聚集之地，奇珍异宝数不胜数，你选择投资",bgSpPath:"11",startSound:"",items:[["4","5"],["12","13"],["16","17"]]},
            {id:"1012",weight:7,name:"NP城",explain:"PP城鱼龙混杂之地，也是一些人的圣地，你选择投资",bgSpPath:"12",startSound:"",items:[["0","1"],["2","3"],["4","5"],["16","17"]]},
            {id:"1013",weight:7,name:"夷陵城",explain:"夷陵城造洪水灾害席卷，你选择投资",bgSpPath:"13",startSound:"",items:[["0","1"],["2","3"],["4","5"],["18","19"]]},
            {id:"1014",weight:7,name:"四号营地",explain:"四号营地军团常年驻扎，以武立城之地，你选择投资",bgSpPath:"14",startSound:"",items:[["0","1"],["2","3"],["4","5"],["6","7"],["8","9"],["14","15"],["18","19"],["24","25"],["28","29"]]},      
        ];
    }
    return cityAry;
}

export enum investOpenType{
    //普通打开
    normal,
    //西湖
    driftBottle
}